const Style = ({ attributes, clientId }) => {
	const { alignment, width, height } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		#pebPDFEmbed-${clientId} .pebPDFEmbed{
			text-align: ${alignment};
		}
		#pebPDFEmbed-${clientId} .pebPDFEmbed .pebSizedContainer{
			width: ${['0px', '0%', '0em'].includes(width) ? 'auto' : width};
			height: ${['0px', '0vh', '0em'].includes(height) ? 'auto' : height};
		}
		#pebPDFEmbed-${clientId} .pebPDFEmbed .pebInLine{
			width: ${['0px', '0%', '0em'].includes(width) ? 'auto' : width};
		}
	`}} />;
}
export default Style;